



















































































import { Component, Vue } from "vue-property-decorator";
import { CompanyDetailsModule } from "@/store/modules/companyDetails";
import CompanyAddressDto from "@/models/CompanyAddresses/CompanyAddressDto";
import CompanyAddressCreate from "@/components/Companies/CompanyAddressCreate.vue";
import GiganautVue from "@/components/Shared/GiganautVue";

@Component({
  name: "CompanyAddressMasterDetails",
  components: { CompanyAddressCreate },
})
export default class extends GiganautVue {
  async created() {
    await CompanyDetailsModule.getCompanyAddresses();
  }

  async updateCurrentCompanyAddress(companyAddress: CompanyAddressDto) {
    await CompanyDetailsModule.updateCurrentCompanyAddress(companyAddress);
  }

  get currentCompanyAddress() {
    return CompanyDetailsModule.currentCompanyAddress;
  }

  get loadingCompanyAddresses() {
    return CompanyDetailsModule.loadingCompanyAddresses;
  }

  get companyAddresses() {
    return CompanyDetailsModule.companyAddresses;
  }
}
